<template>
  <div>
    <div class="layout">
      <div class="int-txt">
        <div class="int-inner">
          <p class="text">
            문화셈터는 문화체육관광 분야 대국민 통계포털서비스로서 문화체육관광 분야의 산재된 통계를 한곳에 모아 국민 누구나 쉽게 조회하고 활용할 수 있도록 지원하는 문화체육관광 통계 포털입니다.
          </p>
        </div>
      </div>
    </div>
    <div class="layout">
      <div class="introduce-wrap">
        <h2 class="title">문화셈터 소개</h2>
        <p class="title-info-txt">
          문화셈터에서는 문화체육관광부 및 산하 기관에서 생산된 문화, 예술, 콘텐츠, 관광, 체육 등의 통계   자료를 수집 관리하며 데이터 분석 및 정책수립, 연구, 동향 분석 등에 활용하도록 다양한 형태의 통계데이터를 제공하고 있습니다.
          <br>
          문화체육관광부 및 산하 공공기관 등이 생산하는 국가승인통계는 총 33종이며, 이중 문화셈터에서 24종의 승인통계를 제공하고 있습니다.
        </p>

        <h2 class="title">문화셈터 주요 서비스</h2>
        <p class="title-info-txt">
          문화셈터에서는 국가승인통계의 조사, 보고통계에 대한 데이터 및 콘텐츠를 사용자들이 활용하기 용이하도록 다양한 형태로 제공하고 있습니다.
        </p>

        <div class="stats-wrap">
          <div class="stats-card">
            <p class="stats-title">• 통계데이터 서비스</p>
            <div class="stats-img"></div>
          </div>

          <div class="stats-card">
            <p class="stats-title">• 통계시각화 서비스</p>
            <div class="stats-img"></div>
          </div>

          <div class="stats-card">
            <p class="stats-title">• MDSS 서비스</p>
            <div class="stats-img"></div>
          </div>

          <div class="stats-card">
            <p class="stats-title">• 통계보고서 서비스</p>
            <div class="stats-img"></div>
          </div>

          <div class="stats-card">
            <p class="stats-title">• OPEN API 서비스</p>
            <div class="stats-img"></div>
          </div>

          <div class="stats-card">
            <p class="stats-title">• E-나라지표</p>
            <div class="stats-img"></div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
      name: 'McstStatInfo',
    mounted() {
    },
    methods: {
    }
  }
</script>

<style scoped>

  @media (width > 1024px) {
    .int-txt {
      display: flex;
      gap: 0 30px;
      margin-bottom: 50px;
      padding-top: 30px;
    }
}

  .int-txt {
    padding: 30px 20px;
    border: 3px solid #969DCC;
    margin: 30px 0 30px 0;
    border-radius: 20px;
    background-color: rgba(150, 157, 204, 0.15);
    align-items: center;
  }

  .int-txt .text {
    line-height: 1.5;
    font-weight: 400;
    font-size: 21px;
  }

  .title-info-txt {
    font-size: 23px;
  }

  .stats-wrap {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 30px;
    max-width: calc(400px * 3 + 30px * 2);
    margin: 30px auto;
  }

  /* 모바일 */
  @media (max-width: 768px) {
    .stats-wrap {
      grid-template-columns: 1fr;
      gap: 16px;
      margin: 16px;
    }
  }

  /* 카드 */
  .stats-card {
    width: 100%;
    background: #FFF;
    border: 3px solid #5A6ACF;
    border-radius: 30px;
    padding: 20px 20px;
    box-sizing: border-box;
    text-align: center;
  }

  .stats-img {
    width: 100%;
    aspect-ratio: 16 / 9;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .stats-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .stats-card:nth-child(1) .stats-img {
    background-image: url('../../assets/img/mcstStatInfo/mcst-stat-info-1.png');
  }

  .stats-card:nth-child(2) .stats-img {
    background-image: url('../../assets/img/mcstStatInfo/mcst-stat-info-2.png');
  }

  .stats-card:nth-child(3) .stats-img {
    background-image: url('../../assets/img/mcstStatInfo/mcst-stat-info-3.png');
  }

  .stats-card:nth-child(4) .stats-img {
    background-image: url('../../assets/img/mcstStatInfo/mcst-stat-info-4.png');
  }

  .stats-card:nth-child(5) .stats-img {
    background-image: url('../../assets/img/mcstStatInfo/mcst-stat-info-5.png');
  }

  .stats-card:nth-child(6) .stats-img {
    background-image: url('../../assets/img/mcstStatInfo/mcst-stat-info-6.png');
  }
</style>
